export default __webpack_public_path__ + "static/media/go-tankless-image2.0bcac3de.png";